<template>
  <section class="detail-info-group">
    <div class="detail-info-group__header">
      <div class="detail-info-group__title">{{ title }}</div>
      <slot name="action" />
    </div>
    <div class="detail-info-group__content">
      <slot />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DetailInfoGroup',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
})
</script>

<style scoped>
.detail-info-group {
  min-width: 0;
}

.detail-info-group__header {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 28px;
  margin-bottom: 8px;
}

.detail-info-group__title {
  color: #111827;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.detail-info-group__content {
  min-width: 0;
}
</style>
